import React from 'react';
import FormButton from '../../library/form/components/FormActionButton2';

const DocRowContainer = (props) => {
    const { formObject, rowKey, containerClass, actionClass, children  } = props;
    //containerElement = containerElement || div;
    return (
        <div className={containerClass || 'uiRowWrap10 uiFormMini'}>
            
            {children}

            <div className={actionClass || 'uiSpacer3 uiContentRight uiActionBlock'}>
                <FormButton formObject={formObject} rowKey={rowKey}
                    starIcon="edit"
                    onlyIcon={true}
                    tooltip="Edit"
                    starIconClassName="uiColorNeutralAction"
                    action={{ actionId: "edit", paramName: "editAction", actionParam: {}, containerKey: "popup" }}
                    className=""></FormButton>
                <FormButton formObject={formObject} rowKey={rowKey}
                    starIcon="clear"
                    onlyIcon={true}
                    tooltip="Delete"
                    starIconClassName="uiColorNegativeAction"
                    action={{ actionId: "del", paramName: "delAction", actionParam: {}, containerKey: "row" }}
                    className=""></FormButton>
            </div>
        </div>
    )
}

export default DocRowContainer
